import {gql} from 'apollo-boost';

export const GET_VDOSETTOPIC = gql`
  query getVdoSetTopic($id : ID!){
    getVdoSetTopic (
      id: $id
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      isEnabled
      remark
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const GET_VDOSETTOPICS_BY_FILTER = gql`

  query getVdoSetTopicsByFilter($vdoSetTopicFilterInput: VdoSetTopicFilterInput){
    getVdoSetTopicsByFilter (
      vdoSetTopicFilterInput:$vdoSetTopicFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input VdoSetTopicFilterInput {
      #      courseOutlineId: ID
      #      vdoSetId: ID
      #      vdoSetUnitId: ID
      #      teacherId: ID
      #      no: Int
      #      nameLocal: String
      #      nameEng: String
      #      isEnabled: Boolean
      #  }
    ){
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      isEnabled
      remark
      courseOutline{
        id
      }
      vdoSet{
        id  code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }

    }
  }
`;

export const GET_VDOSETTOPICS = gql`
  query getVdoSetTopics {
    getVdoSetTopics {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      isEnabled
      remark
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng  nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const ADD_VDOSETTOPIC = gql`
  mutation addVdoSetTopic(
    $vdoSetId: ID!,
    $vdoSetUnitId: ID!,
    $courseOutlineId: ID!,
    $teacherId: ID!,
    $vdoSetTopicInput: VdoSetTopicInput!
  ) {
    addVdoSetTopic(
      vdoSetId: $vdoSetId
      vdoSetUnitId: $vdoSetUnitId
      courseOutlineId: $courseOutlineId
      teacherId: $teacherId
      vdoSetTopicInput: $vdoSetTopicInput
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      isEnabled
      remark
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      bunnyStatusAt
      descriptionLocal
      descriptionEng
      thumbnail
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const UPDATE_VDOSETTOPIC = gql`
  mutation updateVdoSetTopic(
    $id: ID!,
    $teacherId: ID!,
    $vdoSetTopicInput: VdoSetTopicInput!
  ) {
    updateVdoSetTopic(
      id: $id
      teacherId: $teacherId
      vdoSetTopicInput: $vdoSetTopicInput
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      isEnabled
      remark
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      bunnyStatusAt
      descriptionLocal
      descriptionEng
      thumbnail
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const UPDATE_ONLY_VDOSETTOPIC = gql`
  mutation updateOnlyVdoSetTopic(
    $id: ID!,
    $teacherId: ID!,
    $vdoSetTopicInput: VdoSetTopicInput!
  ) {
    updateOnlyVdoSetTopic(
      id: $id
      teacherId: $teacherId
      vdoSetTopicInput: $vdoSetTopicInput
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      isEnabled
      remark
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      bunnyStatusAt
      descriptionLocal
      descriptionEng
      thumbnail
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const DELETE_VDOSETTOPIC = gql`
  mutation deleteVdoSetTopic($id: ID!) {
    deleteVdoSetTopic(
      id: $id
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      isEnabled
      remark
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      bunnyStatusAt
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const DELETE_ONLY_VIDEO = gql`
  mutation deleteOnlyVideo($id: ID!) {
    deleteOnlyVideo(
      id: $id
    ) {
      id
      no
      nameLocal
      nameEng
      vdoLength
      vdoStreamPath
      playbackUrl
      playbackStatus
      isEnabled
      remark
      videoProvider
      bunnyVideoGuid
      bunnyStatus
      bunnyStatusAt
      courseOutline{
        id
      }
      vdoSet{
        id code description totalVdoLength
        subject{
          id code nameLocal nameEng
        }
      }
      vdoSetUnit{
        id unitSeq code totalVdoLength
        courseOutlineUnit{
          id nameLocal nameEng
        }
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng nameShortLocal nameShortEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
    }
  }
`;

